import _ from 'lodash'
import { createSelector } from 'reselect'

export const getNotifications = state => state.toasterReducer.notifications
export const getShowableNotifications = createSelector([getNotifications], (notifications) => {
    const result = _.pickBy(
        notifications,
        notification =>
            // Not dismissed
            notification.dismissed == null &&
            // visible
            notification.visible,
    )
    // console.log('getShowableNotifications: ', result)
    return result
})



// WEBPACK FOOTER //
// ./src/features/Toaster/data/notifications/selectors.js